import './Home.css';
import React from 'react';
import heroImg from '../../assets/heroimg.jpeg';
import Resume from '../../assets/Resume.pdf';
import TextSpan from '../Animation/TextSpan';
import { FaGithub, FaLinkedin, FaEnvelope, FaFileDownload } from 'react-icons/fa';

const Home = () =>{
    const sentence1 = "Hello, ".split("");
    const sentence2 = "I'm Rahul".split("");
    const sentence3 = "Full Stack Developer".split("");

    return(
        <section id='intro'>
            {/* Aesthetic SVG Background Elements */}
            <div className='hero-bg-shapes'>
                <svg className='shape-circle' viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="100" cy="100" r="80" fill="url(#gradient1)" opacity="0.3" />
                    <defs>
                        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" style={{stopColor: '#1abc9c', stopOpacity: 0.8}} />
                            <stop offset="100%" style={{stopColor: '#ffd700', stopOpacity: 0.8}} />
                        </linearGradient>
                    </defs>
                </svg>
                
                <svg className='shape-blob-1' viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                    <path fill="url(#gradient2)" d="M39.5,-65.5C51.4,-58.5,61.5,-48.1,68.3,-35.8C75.1,-23.6,78.6,-9.5,77.8,4.3C77,18.1,71.9,31.6,63.5,42.5C55.1,53.4,43.4,61.7,30.3,66.8C17.2,71.9,2.7,73.8,-12.3,72.8C-27.3,71.8,-42.8,67.9,-54.5,58.5C-66.2,49.1,-74.1,34.2,-76.8,18.2C-79.5,2.2,-77,-14.9,-69.8,-28.5C-62.6,-42.1,-50.7,-52.2,-37.5,-58.5C-24.3,-64.8,-9.8,-67.3,3.5,-72.8C16.8,-78.3,27.6,-72.5,39.5,-65.5Z" transform="translate(100 100)" opacity="0.2" />
                    <defs>
                        <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" style={{stopColor: '#45b39d', stopOpacity: 0.6}} />
                            <stop offset="100%" style={{stopColor: '#0e6251', stopOpacity: 0.6}} />
                        </linearGradient>
                    </defs>
                </svg>
                
                <svg className='shape-blob-2' viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                    <path fill="url(#gradient3)" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,79.6,-45.8C87.4,-32.5,90,-16.2,88.5,-0.9C87,14.4,81.4,28.8,73.1,41.8C64.8,54.8,53.8,66.4,40.3,73.2C26.8,80,10.8,82,-5.1,80.1C-21,78.2,-36.9,72.4,-50.3,63.3C-63.7,54.2,-74.6,41.8,-80.8,27.1C-87,12.4,-88.5,-4.6,-84.3,-19.8C-80.1,-35,-70.2,-48.4,-57.5,-56.1C-44.8,-63.8,-29.3,-65.8,-14.6,-68.6C0.1,-71.4,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100)" opacity="0.15" />
                    <defs>
                        <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" style={{stopColor: '#ffd700', stopOpacity: 0.5}} />
                            <stop offset="100%" style={{stopColor: '#ff6b6b', stopOpacity: 0.5}} />
                        </linearGradient>
                    </defs>
                </svg>

                <div className='floating-dots'>
                    <span className='dot dot-1'></span>
                    <span className='dot dot-2'></span>
                    <span className='dot dot-3'></span>
                    <span className='dot dot-4'></span>
                    <span className='dot dot-5'></span>
                </div>
            </div>

            <div className='hero-container'>
                <div className='intro-content'>
                    <span className='hello'>
                        {sentence1.map((letter, index)=>(
                            <TextSpan key={index}>
                                {letter}
                            </TextSpan>
                        ))}
                    </span>
                    <span className='intro-text'>
                        {sentence2.map((letter, index)=>(
                            <span key={index}>
                                {letter}
                            </span>
                        ))}
                    </span>
                    <span className='intro-para'>
                        {sentence3.map((letter, index)=>(
                            <TextSpan key={index}>
                                {letter === " " ? "\u00A0" : letter}
                            </TextSpan>
                        ))}
                    </span>
                    <p className='intro-description'>
                        Passionate about building innovative web solutions and creating exceptional user experiences.
                    </p>
                    <div className='hero-buttons'>
                        <a href={Resume} target='_blank' rel="noreferrer">
                            <button className='resume-button primary-btn'>
                                <FaFileDownload /> Download Resume
                            </button>
                        </a>
                        <a href='#projects'>
                            <button className='resume-button secondary-btn'>
                                View Projects
                            </button>
                        </a>
                    </div>
                    {/* <div className='social-links-hero'>
                        <a href='https://github.com/rahulkundu1209' target='_blank' rel='noreferrer' aria-label='GitHub'>
                            <FaGithub />
                        </a>
                        <a href='https://linkedin.com/in/rahulkundu1209' target='_blank' rel='noreferrer' aria-label='LinkedIn'>
                            <FaLinkedin />
                        </a>
                        <a href='#contact' aria-label='Contact'>
                            <FaEnvelope />
                        </a>
                    </div> */}
                </div>

                <div className='hero-image-container'>
                    <div className='hero-image-wrapper'>
                        <img src={heroImg} alt='Rahul Kundu' className='hero-img'/>
                        <div className='image-glow'></div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Home;